import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FpcCategoriesPage = lazy(() => import('~/features/configuration/pages/fpc-categories-page'));

/**
 * FPC Categories — `/configuration/fpc-categories`. Meta's published product
 * taxonomy, mirrored verbatim. Access is inherited from the parent `/configuration`
 * route guard (`requirePermission(Screens.CONFIGURATION)`); the page is
 * platform-agnostic reference data, so it ignores the inherited `?platform` param.
 *
 * Surfaces in the sidebar once `/screens/navigation` lists this path (or an ancestor
 * of it) for the tenant — the same gate GPC Categories sits behind, applied by
 * `ConfigurationNavLink`.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/fpc-categories')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FpcCategoriesPage />
    </Suspense>
  ),
});
